import store from '../store/store';
import { LOGOUT } from '../store/user/types';
import logger from './logging';
import snackBar, { SnackBarConfig } from "./snackBar/SnackBar";

// TODO: Add logic for an error object as an array

class AxiosConfig {
    config: { headers: { 'content-type': string, 'authorization': string } };
    token: string;
    sessionKey: string;
    minConfig: { headers: { "authorization": string } };
    tokenType: string;

    constructor() {
        this.config = {
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'authorization': '',
            }
        };
        this.minConfig = {
            headers: {
                'authorization': '',
            }
        }
        this.tokenType = "";
        this.token = "";
        this.sessionKey = "";
    }

    setupConfig(token_type: string, access_token: string, sessionKey?: string) {
        const newConfig = {
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'authorization': `${token_type} ${access_token}`
            }
        }
        const newMinConfig = {
            headers: {
                'authorization': `${token_type} ${access_token}`
            }
        }
        this.config = newConfig;
        this.minConfig = newMinConfig;
        this.tokenType = token_type;
        this.token = access_token;
        if (sessionKey) {
            // //console.log("Saving Session Key", sessionKey);
            this.sessionKey = sessionKey;
        }
        return newConfig;
    }

    sessionKeyValue() {
        // //console.log("Session Key Value", this.sessionKey);
        return this.sessionKey;
    }

    tokenValue() {
        // //console.log("Token Value : ", this.token);
        return this.token;
    }

    configValue(type: "default" | "test" | "min" = "default") {
        if (type === "test") {
            return ({
                headers: {
                    'authorization': `bearer test_token_for_error_handling_plz_ignore`
                }
            })
        }
        if (type === "min") {
            // //console.log("Config Value", this.config)
            return { ...this.minConfig };
        } else {
            // //console.log("Config Value", this.config)
            return { ...this.config };
        }
    }

    handleError(error: any) {
        //console.log("AxiosConfig.handleError", error, error?.response);
        let errorStatus: number = 0;
        if (typeof error === "number" || typeof error === "string") {
            errorStatus = Number(error);
        }
        if (error) {
            if (error.status) {
                errorStatus = Number(error.status);
            }
            if (error.response) {
                if (error.response.status) {
                    errorStatus = Number(error.response.status);
                }
            }
        }
        // Switch statement goes through known error messages and can
        // act upon redux to logout/display messages, etc. If a found error status
        // isn't found it returns the error (only errorMessage?) to original caller 
        logger.Info({
            EventMessage: `AxiosConfig handleError called. Status (${errorStatus})`,
            EventCategory: "httprequest"
        });
        // //console.log("Final error status", errorStatus);
        switch (errorStatus) {
            case 401:
                // store.dispatch({ type: LOGOUT });
                break;
            default:
                return errorStatus;
        }
    }

    clearConfig() {
        this.config = {
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'authorization': '',
            }
        }
        return this.config;
    }

    checkArrayOfResponses(responses: any[], config: any) {
        // //console.log("Checking Array of Responses", responses);
        let isSuccessful = true;
        responses.forEach(response => {
            let success = this.checkResponse(response, config);
            // //console.log("Checking Response", response, success);
            if (!success) {
                isSuccessful = false;
            }
        });
        return isSuccessful;
    }

    checkResponse(response: any, config: {
        showSnackbar?: boolean,
        alertOnNull?: boolean,
        alertOnSuccess?: boolean,
        snackBar?: SnackBarConfig,
        successMessage?: string,
        nullMessage?: string
    } = {
            showSnackbar: true,
            alertOnNull: false,
            alertOnSuccess: false,
            successMessage: "Success",
            snackBar: {
                type: "error",
                text: "No Response",
                timeout: 3000
            },
            nullMessage: `There was an error processing your request.`
        }): boolean {
        if (config) {
            config = {
                showSnackbar: true,
                alertOnNull: false,
                alertOnSuccess: false,
                successMessage: "Success",
                snackBar: {
                    type: "error",
                    text: "No Response",
                    timeout: 3000
                },
                nullMessage: `There was an error processing your request.`,
                ...config
            };
        }
        let isSuccess: boolean = true;
        if (response === null && config.alertOnNull) {
            isSuccess = false;
            // //console.log("CheckingResponse1");
            config.showSnackbar && snackBar({ text: "No Response", type: "warning", timeout: 3000, ...config.snackBar });
            return isSuccess;
        } else if (response.error || response.Error) {
            const err: any = response.error || response.Error;
            const message: string = err.message || err.Message || err.ErrorMessage;
            const overrideSuccess: boolean | null = null || err.Success || err.success || err.isSuccess || err.IsSuccess;
            //? Checking if success should be overridden
            if (overrideSuccess !== null && overrideSuccess === true) {
                isSuccess = true;
                // (config.showSnackbar && config.successMessage) && snackBar({text: config.successMessage, type: "success", timeout: 3000});  
            }
            if (!isSuccess && !message && config.nullMessage !== null) {
                // //console.log("CheckingResponse2");
                isSuccess = false;
                config.showSnackbar && snackBar({ text: config.nullMessage, type: "error", timeout: 3000, ...config.snackBar })
                return isSuccess;
            }
            if (!overrideSuccess) {
                // //console.log("CheckingResponse3");
                isSuccess = false;
                config.showSnackbar && snackBar({ text: message, type: "error", timeout: 3000, ...config.snackBar });
                return isSuccess;
            }
            if (config.showSnackbar && message) {
                // //console.log("CheckingResponse7");
                snackBar({ ...config.snackBar, text: message, type: "error" })
            }
            (config.showSnackbar && message) && snackBar({ ...config.snackBar, text: message });
            if (!message && config.alertOnSuccess) {
                // //console.log("CheckingResponse4");
                isSuccess = true;
                snackBar({ type: "success", text: config.successMessage || "", timeout: 3000 });
                return isSuccess;
            }
            // if(err){ isSuccess = false; }
        } else if (response.data) {
            let Error: any = response.data.Error || response.data.error;
            if (Error) {
                let ErrorMessage: string = Error.Message || Error.message || Error.ErrorMessage || Error.errorMessage;
                let IsSuccessful: boolean = Error.IsSuccess || Error.isSuccess || Error.success || Error.Success || false;
                //TODO: Add more error handling / add code filter
                if (!IsSuccessful && ErrorMessage) {
                    // //console.log("CheckingResponse5");
                    isSuccess = false;
                    snackBar({ ...config.snackBar, type: "error", text: ErrorMessage });
                    return isSuccess;
                } else if (!IsSuccessful && !ErrorMessage && config.nullMessage) {
                    // //console.log("CheckingResponse6");
                    isSuccess = false;
                    snackBar({ ...config.snackBar, type: "error", text: config.nullMessage });
                    return isSuccess;
                }
            }
        }
        if (isSuccess && config.alertOnSuccess) {
            snackBar({ type: "success", text: config.successMessage || "", timeout: 3000 });
            return isSuccess;
        }
        return isSuccess;
    }
}
//r-18-lint-dj
//eslint-disable-next-line
export default new AxiosConfig();